import styled from 'styled-components';
import Palette from '../../common/Palette';

export const RootContainer = styled.div`
  --sg-right-panel-width: 23.063rem; /* 20.063rem + 3rem total right space */
  --sg-navigation-gap: 0rem;
  height: calc(100vh - 1.6rem);
  overflow: hidden;
  overflow-y: auto;
  margin: 0 0 0 30px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  &.no-overflow {
    overflow: hidden;
  }
  @media only screen and (max-width: 704px) {
    display: none;
  }

  &.scrolled .resultPanelHeader {
    box-shadow: -4px 4px 6px 0px ${Palette.GREY};
  }

  &.panel-collapsed {
    --sg-right-panel-width: 0rem;
    --sg-navigation-gap: 4.5rem;
  }
`;

export const LeftPanel = styled.div`
  height: 100%;
  width: calc(100% - var(--sg-right-panel-width));
  transition: width 0.3s ease-in-out;
  
  &.expanded {
    width: calc(100% - 1rem); /* Matches nav width calculation */
  }
`;

export const RightPanel = styled.div`
  position: absolute;
  top: 1rem;
  bottom: 1rem;
  right: 1rem;
  width: 20.063rem;
  box-shadow: rgba(9, 30, 66, 0.2) 0px 3px 5px, rgba(9, 30, 66, 0.31) 0px 0px 1px;
  overflow: hidden;
  background: var(--sg-bg-primary, #ffffff);
  border: 1px solid var(--sg-border-default, #ebecf0);
  border-radius: 12px;
  height: auto;
  z-index: 1;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  
  &.collapsed {
    transform: translateX(calc(100% + 2rem));
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    width: 0;
    min-height: 0;
    height: 0;
    top: 0;
    bottom: auto;
    overflow: hidden;
  }
`;

export const CollapsedPanelButton = styled.button`
  position: fixed;
  top: 1.5rem;
  right: 1rem;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(90deg, rgb(98, 74, 182) 47.54%, rgb(232, 113, 138) 190.03%);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(9, 30, 66, 0.2) 0px 3px 5px, rgba(9, 30, 66, 0.31) 0px 0px 1px;
  z-index: 60;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px, rgba(9, 30, 66, 0.31) 0px 0px 1px;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

export const DefaultMessageContainer = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  color: rgb(28, 43, 75);
  padding: 1.25rem;
  display: none;
  flex-direction: column;
  gap: 0.813rem;
  align-items: baseline;
  box-shadow: 0px 3px 14px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 0.375rem;
  @media only screen and (max-width: 704px) {
    display: flex;
  }
  .paddingContainer {
    padding-bottom: 1.25rem;
  }
`;
